export const zh = {
    "Add": "添加{0}",
    "Edit": "编辑{0}"
}